import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { CurrencyPipe, NgClass, NgStyle } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { GalleryComponent } from '../gallery.component';
import { FooterType03Component } from "../../../../layout/common/footer/footer-type03/footer-type03.component";

@Component({
  selector: 'gallery-type01',
  standalone: true,
  imports: [MatIconModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, FormsModule, RouterModule, DestinationListType01Component, CurrencyPipe, NgClass, MatTabsModule, NgStyle, GalleryComponent, FooterType03Component],
  templateUrl: './gallery-type01.component.html',
  styleUrl: './gallery-type01.component.scss'
})
export class GalleryType01Component {

  public view: any = {
   
  };

  constructor(private route: ActivatedRoute, private router: Router, private tfmService: TFMService, private _cd: ChangeDetectorRef) {
  }
  activeTabIndex = 0;

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
  }

  getBackgroundImage(index: number): string {
    const images = [
      'url("https://bahiashipping.ph/assets/12-Pf5ndnpz.png")',
      'url("https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGNydWlzZXxlbnwwfHwwfHx8MA%3D%3D")',
      'url("https://cdn.pixabay.com/photo/2013/06/08/04/17/ferry-boat-123059_1280.jpg")',
      'url("https://media.istockphoto.com/id/155375632/photo/tropical-paradise.jpg?s=612x612&w=0&k=20&c=pkKzP9C7hmjiplWWz_8fZf2NlwXIi9sn9GKY85QiQV8=")',
    ];
    return images[index] || images[0];
  }

  getTitle(index: number): string {
    const titles = [
      'Cunard',
      'Hurtigruten',
      'Luxury Cruises',
      'Expedition Cruises',
    ];
    return titles[index] || titles[0];
  }

  getDescription(index: number): string {
    const descriptions = [
      'Imagine a journey that etches unforgettable memories into your heart...',
      'Explore the world with our amazing cruise adventures...',
      'Experience luxury like never before on our luxury cruises...',
      'Join us on an expedition to the most remote parts of the world...',
    ];
    return descriptions[index] || descriptions[0];
  }
}
